<template>
  <div>
  <div class="galaxy">
    <div class="glot-extension-bg"></div>
    <div class="glot-extension-linear"></div>
    <div class="glot-extension-overlay"></div>
    <div class="min-h-screen flex w-full bg-img vx-row no-gutter items-center justify-center relative" id="page-login">
    <div class="vx-col sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/5 sm:m-0">
        <div slot="no-body" class="full-page-bg-color">
             <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col" style="max-width: 500px">
                <div class="flex w-full login-tabs-container flex-col min-h-screen justify-around py-2">

                    <div class="flex w-full bg-img no-gutter items-center justify-center flex-col">
                      <div class="flex w-full items-end flex-col justify-center">
                      <i18n class="mb-4 mr-2"/>
                      <div class="w-full">
                        <vx-card class="glot-background-color-transparent">
                          <div slot="no-body" class="full-page-bg-color">
                            <div class="vx-row no-gutter justify-center items-center">
                              <div class="vx-col sm:w-full md:w-full lg:w-full">
                                <div class="px-8 py-8 pb-3 login-tabs-container">
                                  <div class="vx-card__title">
                                    <div v-if="$route.meta.canBackLogin" @click="backToLogin" class="glot-text-color-99 flex items-center cursor-pointer glot-text-font-size-16 glot-text-line-height-20">
                                     <vs-icon icon="icon-chevron-left" icon-pack="feather" size="16px"/> {{$t('Back')}}
                                    </div>
                                    <div class="glot-text-color-EB flex items-center justify-center mb-10">
                                      <img :src="getImgUrl()" style="" class="inline-block"/>
                                    </div>
                                  <router-view
                                  :key="$route.fullPath"
                                  :nameDomain="nameDomain"
                                  />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </vx-card>
                      </div>
                      </div>

                    <div v-if="$route.name === 'register' || $route.name === 'login'">
                    <p class="sign-in-caveat text-center glot-text-color-80 glot-text-font-size-12 glot-text-line-height-16 mb-8">{{ $route.name === 'login' ? $t("SignInCaveat") : $t("SignUpCaveat")}}</p>
                    <div class="text-center mb-4">
                      <span class="glot-text-color-EB mb-1 glot-text-font-size-16 glot-text-line-height-24">{{ $route.name !== 'register' ? $t("CreateAccQuest") : $t("LoginAccQuest")}}</span>
                      <a tabindex="0" @keyup.enter.prevent="changePage" class="glot-text-color-1D ml-1 cursor-pointer glot-text-font-size-16 glot-text-line-height-20" @click="changePage">{{$route.name !== 'register' ? $t("SignUpNow") : $t("Login")}}</a>
                    </div>
                    </div>

                    </div>

                <div class="px-8">
                  <div  v-if="$route.name === 'register' || $route.name === 'login' || $route.name === 'verificationSuccess'" class="vx-card__title mb-4">
                    <hr class="glot-background-border-color-41 mb-8"/>
                    <p class="text-center glot-text-color-80 mb-3 glot-text-font-size-12 glot-text-line-height-16">{{$t("OtherPlatformsCaveat")}}</p>
                    <div class="plat-form-container text-center">
                      <a href="https://ejo.bz/go-web" target="_blank"><img src="@/assets/images/svg/icons/ejoyGo.svg" class="mx-2 cursor-pointer"/></a>
                      <a href="https://ejo.bz/epic-web" target="_blank"><img class="mx-2 cursor-pointer" src="@/assets/images/icons/ejoyEpic.png"/></a>
                      <a href="https://ejo.bz/ejoy-app-lp" target="_blank"><img src="@/assets/images/svg/icons/ejoyEnglish.svg" class="mx-2 cursor-pointer"/></a>
                      <a href="https://ejo.bz/reader-lp" target="_blank"><img class="mx-2 cursor-pointer" src="@/assets/images/icons/ejoyReader.png"/></a>
                      <a href="https://ejo.bz/ejoy-ext-lp" target="_blank"><img src="@/assets/images/svg/icons/ejoyExtension.svg" class="mx-2 cursor-pointer"/></a>
                      <a href="https://ejo.bz/Glot-ext-lp" target="_blank"><img src="@/assets/images/svg/icons/ejoyGlot.svg" class="mx-2 cursor-pointer"/></a>
                    </div>
                  </div>
                  <div class="text-center flex justify-center glot-text-font-size-12 glot-text-line-height-16">
                    <span class="mx-2">{{$t('CopyRight', {year:yearNow})}}</span>
                    <div class="inline-block w-px glot-background-color-EB opacity-50 rounded-full"/>
                    <a target="_blank" href="https://help.glotdojo.com/terms" tabindex="0" class="glot-text-color-1D mx-2 glot-text-font-size-12 glot-text-line-height-16 cursor-pointer">{{$t('TermOfUse')}}</a>
                    <div class="inline-block w-px glot-background-color-EB opacity-50 rounded-full"/>
                    <a target="_blank" href="https://help.glotdojo.com/policy/" tabindex="0" class="glot-text-color-1D mx-2 glot-text-font-size-12 glot-text-line-height-16 cursor-pointer">{{$t('PrivacyPolicy')}}</a>
                  </div>
                  <div id="glot-sso-version" style="color: black; font-size: .25rem">Version {{version}}</div>
                </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </div>
        </div>
    </div>
</template>

<script>

import I18n from '@/components/I18n.vue'
import json from '../../../app.json'

import { NAME_FOR_DOMAIN } from '../../config/commonConfig'

const { BroadcastChannel } = require('broadcast-channel')

export default {
  components: {
    I18n
  },
  data () {
    return {
      nameDomain: ['Epic', 'GlotDojo'],
      icon: 'ejoy_logo.svg',
      version: json.version
    }
  },
  watch:{
    '$route' () {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
    }
  },
  computed: {
    yearNow () {
      const d = new Date()
      const n = d.getFullYear()
      return n
    }
  },
  methods: {
    getImgUrl () {
      return require(`@/assets/images/svg/icons/${this.icon}`)
    },
    changePage () {
      if (this.$route.name !== 'register') {
        this.$router.push(`/register${this.$route.fullPath}`)
      } else if (this.$route.name !== 'login') {
        this.$router.push(`/?continue=${localStorage.getItem('continueDomain')}`)
      } 
    },
    backToLogin () {
      this.$router.push(`/?continue=${localStorage.getItem('continueDomain')}`)
    }
  },
  created () {
    if (this.$route.query.continue || this.$route.query.redirect_uri) {
      const url = this.$route.query.continue || this.$route.query.redirect_uri
      NAME_FOR_DOMAIN.map(domain => {
        if (url.startsWith(domain.prefix)) {
          this.nameDomain = domain.name
          if (domain.icon) {
            this.icon = domain.icon
          }
        }
      })
    }
    console.log(this.$t('Back'), 'sdfsdfsdfsdfsdfsdf',  this.$i18n.messages)
    // console.log(this.$t('Back'),'sdfsdfsdfsdfsdfsdf')
  },
  mounted () {
    // const searchParams = new URLSearchParams(this.$route.query)
    const channel = new BroadcastChannel('foobar')
    channel.onmessage = msg => {
      if (msg.focus) {
        console.log('msgsdfsdfsdfsdfsdfsdf')
        if (window.opener) {
          if (msg.focus !== window.opener.parent.glotId) {
            window.close()
          } else if (msg.forceClose) {
            window.close()
          }
        }
      }
    }

    // localStorage.setItem('continueDomain', DEFAULT_DOMAIN)
    if (this.$route.query.continue || this.$route.query.redirect_uri) {
      const url = new URL(this.$route.query.continue || this.$route.query.redirect_uri)
      if (NAME_FOR_DOMAIN[url.host]) {
        this.nameDomain = NAME_FOR_DOMAIN[url.host]
      }
    }
  }
}

</script>